"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _orderHelper = require("../../../helpers/orderHelper");
var _commonComponent = require("../../../propTypes/commonComponent");
var _instrumentPropTypes = require("../../../propTypes/instrumentPropTypes");
var _APButton = _interopRequireDefault(require("../../common/APButton"));
var _APSelect = _interopRequireDefault(require("../../common/APSelect"));
var _AdvancedOrderMarketPrice = _interopRequireDefault(require("./AdvancedOrderMarketPrice"));
var _OrderEntryEstimates = require("../common/OrderEntryEstimates");
var _FormAmountFields = require("../common/FormAmountFields");
var _VerificationRequiredContainer = _interopRequireDefault(require("../../VerificationRequired/VerificationRequiredContainer"));
var _orderEntryFormConstants = require("../../../constants/sendOrder/orderEntryFormConstants");
require("./AdvancedOrderForm.css");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var createFormCls = (0, _cssClassesHelper.getBEMClasses)('advanced-order-form');
var createDividerCls = (0, _cssClassesHelper.getBEMClasses)('divider');
var createPaneCls = (0, _cssClassesHelper.getBEMClasses)('advanced-order-sidepane');
var AdvancedOrderFormComponent = function AdvancedOrderFormComponent(_ref) {
  var handleSubmit = _ref.handleSubmit,
    instruments = _ref.instruments,
    submitting = _ref.submitting,
    clearAdvancedOrderEntryForm = _ref.clearAdvancedOrderEntryForm,
    disableTrading = _ref.disableTrading,
    invalid = _ref.invalid,
    closeSidePane = _ref.closeSidePane,
    isMarginActive = _ref.isMarginActive,
    orderTypes = _ref.orderTypes,
    maxQuantity = _ref.maxQuantity,
    side = _ref.side,
    isBuy = _ref.isBuy,
    reduxFormChange = _ref.reduxFormChange,
    form = _ref.form,
    onSidePaneOpen = _ref.onSidePaneOpen;
  var _useTranslation = (0, _reactI18next.useTranslation)('order'),
    t = _useTranslation.t;
  (0, _react.useEffect)(function () {
    reduxFormChange('limitPrice', '');
    reduxFormChange('stopPrice', '');
    reduxFormChange('value', '');
    reduxFormChange('quantity', '');
  }, [isBuy, reduxFormChange]);
  (0, _react.useEffect)(function () {
    onSidePaneOpen === null || onSidePaneOpen === void 0 || onSidePaneOpen({
      title: t('Advanced Orders'),
      customClass: createPaneCls(),
      classModifiers: 'with-tabs'
    });
  }, [t, onSidePaneOpen]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: createPaneCls('tab-container')
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: createPaneCls('tab', isBuy && 'buy-selected'),
    onClick: function onClick() {
      clearAdvancedOrderEntryForm();
      reduxFormChange('side', _orderEntryFormConstants.buyValue);
    }
  }, t('Buy')), /*#__PURE__*/_react["default"].createElement("button", {
    className: createPaneCls('tab', !isBuy && 'sell-selected'),
    onClick: function onClick() {
      clearAdvancedOrderEntryForm();
      reduxFormChange('side', _orderEntryFormConstants.sellValue);
    }
  }, t('Sell'))), /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: handleSubmit,
    className: createPaneCls('form')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: createFormCls('body')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: createFormCls('main-section')
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: createFormCls(null, ['with-padding'])
  }, /*#__PURE__*/_react["default"].createElement(_APSelect["default"], {
    name: "instrument",
    label: t('Instrument'),
    customClass: createFormCls(),
    options: instruments.map(function (_ref2) {
      var InstrumentId = _ref2.InstrumentId,
        _Symbol = _ref2.Symbol;
      return {
        value: InstrumentId,
        label: _Symbol
      };
    }),
    showTriangles: true
  })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_APSelect["default"], {
    name: "orderType",
    label: t('Order Type'),
    customClass: createFormCls(),
    onChange: clearAdvancedOrderEntryForm,
    options: orderTypes,
    showTriangles: true
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: createFormCls('main-section-limit-price')
  }, /*#__PURE__*/_react["default"].createElement(_AdvancedOrderMarketPrice["default"], {
    baseClass: createFormCls()
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: createDividerCls(null, ['dark', 'advanced-order-side-pane-size'])
  }), /*#__PURE__*/_react["default"].createElement(_FormAmountFields.FormAmountFields, {
    baseClass: createFormCls(),
    formName: form,
    maxQuantity: maxQuantity,
    fieldLayout: "horizontal"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: createDividerCls(null, ['dark', 'advanced-order-side-pane-size-small'])
  }), /*#__PURE__*/_react["default"].createElement(_OrderEntryEstimates.OrderEntryEstimates, {
    baseClass: createFormCls(),
    formName: form,
    isMarginActive: isMarginActive
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: createDividerCls(null, ['dark', 'advanced-order-side-pane-size-small'])
  }), /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    type: "submit",
    disabled: submitting || disableTrading || invalid || !maxQuantity,
    customClass: createFormCls(),
    styleName: !isBuy ? _commonComponent.styleNames.subtractive : _commonComponent.styleNames.additive
  }, submitting ? t('Processing...') : t((0, _orderHelper.getSubmitButtonText)(side))), /*#__PURE__*/_react["default"].createElement("div", {
    className: createFormCls('verification-required')
  }, /*#__PURE__*/_react["default"].createElement(_VerificationRequiredContainer["default"], {
    onVerificationLinkClick: closeSidePane
  })))));
};
AdvancedOrderFormComponent.propTypes = {
  handleSubmit: _propTypes["default"].func.isRequired,
  instruments: _propTypes["default"].arrayOf(_instrumentPropTypes.instrumentPropType).isRequired,
  submitting: _propTypes["default"].bool.isRequired,
  clearAdvancedOrderEntryForm: _propTypes["default"].func.isRequired,
  disableTrading: _propTypes["default"].bool,
  invalid: _propTypes["default"].bool,
  isMarginActive: _propTypes["default"].bool.isRequired,
  orderTypes: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string.isRequired
  })).isRequired,
  maxQuantity: _propTypes["default"].number.isRequired,
  isBuy: _propTypes["default"].bool,
  reduxFormChange: _propTypes["default"].func.isRequired,
  closeSidePane: _propTypes["default"].func.isRequired,
  form: _propTypes["default"].string,
  side: _propTypes["default"].string,
  onSidePaneOpen: _propTypes["default"].func
};
var _default = exports["default"] = AdvancedOrderFormComponent;